/* unplugin-vue-components disabled */import { render } from "./Single.vue?vue&type=template&id=306b64a0&scoped=true"
import script from "./Single.vue?vue&type=script&lang=js"
export * from "./Single.vue?vue&type=script&lang=js"

import "./Single.vue?vue&type=style&index=0&id=306b64a0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-306b64a0"]])

export default __exports__